@custom-media --mobile (max-width: 768px);

.header {
  position: relative;
  z-index: 4;

  @media print {
    display: none;
  }
}

.headerContainer {
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  padding: 0 2rem;

  p {
    margin-bottom: 0;
    font-size: 12px;
  }
}

.topHeader {
  background-color: var(--blueActive);

  &>div {
    height: 40px;
    color: var(--white);
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  & .smallLogo::before {
    font-size: 1.3rem;
    margin-right: 1rem;
  }

  & .smallLogo {
    max-height: 3em;
    margin-right: 1rem;
  }
}

.subHeader {
  background-color: var(--deepBlack);

  &>div {
    min-height: 51px;
    display: flex;
    align-items: center;
  }

  & img.unihowLogo {
    padding-right: 1rem;
    border-right: 1px solid var(--white);
  }
}

button.triggerButton {
  margin-left: auto;
  padding: 0;
  background-color: unset;
  border: none;
  display: inline-flex;
  align-items: center;
  font-weight: 300;
  color: var(--white);

  &>span::after {
    color: var(--white);
    margin-left: 0.5rem;
  }
}

.linkContainer {
  display: flex;
  align-items: center;

  @media (--mobile) {
    display: none;
  }

  &>li>a {
    font-size: 0.9rem;
    color: var(--white);
    padding: 1rem;
    display: block;

    &.active {
      background-color: var(--blue);
    }
  }
}

.mobileMenuTriggerContainer {
  display: none;
  color: var(--white);
  margin-left: 1rem;
  flex-grow: 1;

  @media (--mobile) {
    display: inline;
  }
}

.headerDropDown {
  position: absolute;
  z-index: 100;
  border: 1px solid var(--deepBlack);
  border-top: none;
  min-width: 300px;
  background-color: var(--white);
  box-shadow: 0 3px 0 rgb(0 0 0 / 20%);
}

.userMenu {
  right: 2rem;

  @media (--mobile) {
    right: 0;
  }
}

.mobileMenu {
  left: 0;
}

.menuTitle {
  font-size: 0.85rem;
  color: var(--lightGray);
  padding: 0.5rem;

  p {
    font-size: 0.85rem;
  }
}

.menuOption {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: unset;
  border: none;
  width: 100%;
  text-align: left;

  &:hover {
    background-color: #dff4fd;
  }

  p {
    font-size: 100%;
  }
}

hr.menuDivider {
  border: none;
  border-top: 1px solid var(--deepBlack);
  height: 1px;
  margin: 0;
}
